import React, { useRef, useEffect } from "react";
import "./AlternatingLayout.css";
import { ProductCard } from "../../components/productCard/ProductCard.jsx";

const AlternatingLayout = (props) => {
  const { productSubheader, productDescription, data } = props;
  const itemRefs = useRef([]);

  useEffect(() => {
  const currentItemRefs = itemRefs.current; // snapshot for this effect run

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.3 }
  );

  currentItemRefs.forEach((ref) => {
    if (ref) observer.observe(ref);
  });

  return () => {
    // use the same snapshot, not itemRefs.current
    currentItemRefs.forEach((ref) => {
      if (ref) observer.unobserve(ref);
    });
    observer.disconnect();
  };
}, []);


  return (
    <div className="container">
      <div
        className="intro fade-in"
        ref={(el) => (itemRefs.current[data.length] = el)}
      >
        <div className="header">
          <h2 className="subheading">{productSubheader}</h2>
          <p className="hero__subhead">{productDescription}</p>
        </div>
      </div>
      {data.map((item, index) => {
        const isEven = (index) % 2 === 0;
        return (
          <div
            key={index}
            ref={(el) => (itemRefs.current[index] = el)}
            className={`row ${isEven ? "left" : "right"} fade-in`}
          >
            <div className="image">
            <div className="product-info">
               <div className="product-header">{item.productHeader}</div>
            <ProductCard
              title={item.productHeader}
              img={item.image}
              landScapeImg={false}
            />
            </div>
            </div>

            <div className="description">
              <ul>
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AlternatingLayout;
